var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 3.33398L3.33325 12.6673M5.99992 4.66732C5.99992 5.4037 5.40297 6.00065 4.66659 6.00065C3.93021 6.00065 3.33325 5.4037 3.33325 4.66732C3.33325 3.93094 3.93021 3.33398 4.66659 3.33398C5.40297 3.33398 5.99992 3.93094 5.99992 4.66732ZM12.6666 11.334C12.6666 12.0704 12.0696 12.6673 11.3333 12.6673C10.5969 12.6673 9.99992 12.0704 9.99992 11.334C9.99992 10.5976 10.5969 10.0007 11.3333 10.0007C12.0696 10.0007 12.6666 10.5976 12.6666 11.334Z",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent02);
export default __webpack_public_path__ + "static/media/percent-02.e7e404c9622e90097b6627821fcaa7c1.svg";
export { ForwardRef as ReactComponent };